import React from 'react'

import { find } from 'lodash'
import { useTranslation } from 'react-i18next'
import { connect, getDataClass } from 'scrivito'

import { Card } from '@/Atomic/Atoms/Card'
import { StringText } from '@/Atomic/Atoms/StringText'
import { DataClassName } from '@/Data/const'
import { Contact } from '@/Data/Contact/ContactDataClass'
import { ContactContactRelation } from '@/Data/ContactContactRelation/ContactContactRelationDataClass'
import { SchemaAttributes } from '@/Data/typesV2'
import { getDataItemTitle, getSchemaName } from '@/utils/dataClassMap'
import { getDataItem } from '@/utils/getDataItem'
import { getRelatedContact } from '@/utils/getRelatedContact'
import { getSchema } from '@/utils/getSchema'
import { getLocalizedSchemaAttributes } from '@/utils/schemaLocalization'

interface MyTeamProps {
  id: string
}

export const MyTeamCard: React.FC<MyTeamProps> = connect(({ id }) => {
  const { t } = useTranslation()

  const { schema } = getSchema(
    getSchemaName(DataClassName.CONTACT_CONTACT_RELATION),
  )
  const schemaAttributes = getLocalizedSchemaAttributes(
    schema?.get('attributes') as SchemaAttributes,
  )

  const contactTypes = schemaAttributes?.['contactType']?.enumValues
  const myTeamType = find(
    contactTypes,
    (contactType) => contactType.value === 'myteam',
  )?.value

  if (!myTeamType) {
    return
  }

  const relations = ContactContactRelation.all()
    .transform({ filters: { father: id, contactType: myTeamType } })
    .take()

  if (relations.length <= 0) {
    return
  }

  return (
    <div className="pb-24">
      <div className="group-header">{t('components.myteam.title')}</div>
      <Card>
        <div className="grid-container">
          {relations.map((relation) => {
            const { contactId, dataClassName } = getRelatedContact(relation, id)
            const dataClass = getDataClass(dataClassName) || Contact
            const { dataItem: contact } = getDataItem(dataClass, contactId)

            const role = relation.get('role')
            const roles = schemaAttributes?.['role']?.enumValues
            const roleTitle = find(roles, (r) => r.value === role)?.title

            if (!contact) return null

            return (
              <React.Fragment key={relation.id()}>
                <span className="grid-item key">{roleTitle}</span>
                <span>
                  <StringText
                    variant="link"
                    dataItem={contact}
                    value={getDataItemTitle(contact) || ''}
                  />
                </span>
              </React.Fragment>
            )
          })}
        </div>
      </Card>
    </div>
  )
})
